import styled, { css } from 'styled-components';

export const PricingStyles = styled.div`
  width: 100%;
  max-width: 1000px;
  position: relative;
  font-size: 18px;
  line-height: 24px;
  margin: 0 auto;
  /* text-align: center; */

  .container {
    position: relative;
  }

  .section-head {
    /* max-width: 330px; */
    text-align: center;
    margin: 0 auto 30px;

    .text-box {
      width: 100%;
      margin: 0 auto 25px;
      
      .download-restriction {
        max-width: 450px;
        margin: 0 auto 25px;
      }

      .title {
        display: block;
        font-size: 36px;
        line-height: 40px;
        color: var(--text-color-50);
        margin: 0 0 5px;
      }
    }
  }

  .plans-header {
      max-width: 330px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    padding: 4px;
    text-transform: capitalize;
    border-radius: 100px;
    background: #fafafa;
    margin: 0 auto;

    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-grow: 1;
      gap: 8px;
      min-height: 45px;
      font-weight: 500;
      padding: 10px 15px;
      border-radius: 50px;
      text-align: center;
      color: rgba(49, 49, 49, 0.8);
      outline: none;
      box-shadow: none;
      border: 1px solid transparent;

      .text {
        padding: 5px 10px;
        border-radius: 50px;
        color: var(--white);
        background: #2783ec;
      }

      &.active {
        color: var(--text-color-50);
        border: 1px solid #efefef;
        background: rgba(255, 255, 255, 0.95);
        box-shadow: 0px 0px 0px 1.11px rgba(38, 121, 243, 0.04);
      }
    }
  }
  .pricing-holder {
    text-align: left;
    display: grid;
    gap: 5px;
    grid-template-columns: repeat(1, 1fr);
    overflow: hidden;
    font-size: 14px;
    line-height: 18px;
   
    margin: 0 auto 25px;
    border-radius: 33px;
    border: 1px solid #f0f0f0;

    @media (min-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media (min-width: 992px) {
      grid-template-columns: repeat(3, 1fr);
    }

    .title {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 16px;
      line-height: 20px;
      font-weight: 600;
      text-transform: capitalize;
      margin: 0 0 15px;
      color: var(--text-color-50);

      .icon-box {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 44px;
        height: 44px;
        padding: 5px;
        border-radius: 15px;
        background: #fafafa;
      }
    }
  }

  .points_wrapper {
    overflow: hidden;
    width: 100%;
    height: 95vh;
    pointer-events: none;
    position: absolute;
    inset: 0;
    z-index: 1;
  }

  .points_wrapper .point {
    bottom: -10px;
    position: absolute;
    animation: floating-points infinite ease-in-out;
    pointer-events: none;
    width: 10px;
    height: 10px;
    background: linear-gradient(180deg, #1edce3 0%, #2783ec 100%);
    border-radius: 9999px;
  }
  @keyframes floating-points {
    0% {
      transform: translateY(0);
    }
    85% {
      opacity: 0;
    }
    100% {
      transform: translateY(-300px);
      opacity: 0;
    }
  }
  .points_wrapper .point:nth-child(1) {
    left: 10%;
    opacity: 1;
    animation-duration: 2.35s;
    animation-delay: 0.2s;
  }
  .points_wrapper .point:nth-child(2) {
    left: 30%;
    opacity: 0.7;
    animation-duration: 2.5s;
    animation-delay: 0.5s;
  }
  .points_wrapper .point:nth-child(3) {
    left: 25%;
    opacity: 0.8;
    animation-duration: 2.2s;
    animation-delay: 0.1s;
  }
  .points_wrapper .point:nth-child(4) {
    left: 44%;
    opacity: 0.6;
    animation-duration: 2.05s;
  }
  .points_wrapper .point:nth-child(5) {
    left: 50%;
    opacity: 1;
    animation-duration: 1.9s;
  }
  .points_wrapper .point:nth-child(6) {
    left: 75%;
    opacity: 0.5;
    animation-duration: 1.5s;
    animation-delay: 1.5s;
  }
  .points_wrapper .point:nth-child(7) {
    left: 88%;
    opacity: 0.9;
    animation-duration: 2.2s;
    animation-delay: 0.2s;
  }
  .points_wrapper .point:nth-child(8) {
    left: 58%;
    opacity: 0.8;
    animation-duration: 2.25s;
    animation-delay: 0.2s;
  }
  .points_wrapper .point:nth-child(9) {
    left: 98%;
    opacity: 0.6;
    animation-duration: 2.6s;
    animation-delay: 0.1s;
  }
  .points_wrapper .point:nth-child(10) {
    left: 65%;
    opacity: 1;
    animation-duration: 2.5s;
    animation-delay: 0.2s;
  }

  .footer {
    max-width: 280px;
    margin: 0 auto;
    text-align: center;
    font-size: 14px;
    line-height: 18px;
    color: #808080;

    .team-img {
      display: block;
      margin: 0 auto 10px;
    }

    .text {
      display: block;
      margin: 0 0 7px;

      .link {
        color: #808080;
        font-weight: 600;
      }
    }
  }
`;

export const StyledCol = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  padding: 25px;
  border-left: 1px solid #f0f0f0;
  background: var(--white);

  &:first-child {
    border-left: none;
  }

  &:first-child,
  &:last-child {
    .header {
      .title {
        margin: 0 0 15px;
      }
      p {
        margin-bottom: 25px;
      }
    }
  }

  .header {
    width: 100%;
    min-height: 181px;
    position: relative;
    padding: 0 0 18px;
    margin: 0 0 14px;
    color: #949494;

    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 1px;
      border-bottom: 2px dotted #e6e7ec;
    }

    .plan-name {
      display: flex;
      align-items: center;
      gap: 15px;
    }

    .tag {
      width: 100px;
      height: 26px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 0 0 10px 10px;
      position: absolute;
      top: -25px;
      right: 5px;
      text-align: center;
      font-size: 13px;
      line-height: 16px;
      text-transform: capitalize;
      background: linear-gradient(180deg, #1edce3 0%, #2783ec 100%);
    }
  }

  .price-box {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    margin: 0 0 15px;

    .price {
      display: block;
      font-size: 36px;
      line-height: 40px;
      color: var(--text-color-50);
    }

    .timeline {
      display: block;
      font-size: 16px;
      line-height: 20px;
      text-align: left;
      text-transform: capitalize;
      color: var(--text-color-50);
    }
    sub {
      display: inline-block;
      vertical-align: bottom;
    }

    .text {
      display: block;
      font-size: 12px;
      line-height: 15px;
      color: rgba(136, 133, 129, 0.5);
    }
  }

  .info-list {
    flex-grow: 1;
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      display: flex;
      gap: 10px;
      padding: 5px 0;
    }
    .text {
      color: var(--text-color-50);
    }
    .tick-mark {
      font-size: 20px;
      color: #317bff;
    }
  }

  .see-more button:hover {
    text-decoration: underline;
  }

  ${({ $popularPlan }) =>
    $popularPlan &&
    css`
      color: var(--white);
      background: #1c3253;

      .info-list {
        .text,
        .tick-mark {
          color: var(--white);
        }
      }

      .header {
        color: var(--white);

        &::after {
          background: rgba(255, 255, 255, 0.2);
        }
      }

      .title,
      .subtitle,
      .timeline,
      .text,
      .see-more button {
        color: var(--white) !important;
      }

      .price-box {
        .price {
          color: var(--white) !important;
        }
      }

      button {
        box-shadow: none !important;
      }
    `}
`;
